<template>
  <div class="BackgroundCarousel">
    <el-carousel
      v-if="images.length > 0"
      indicator-position="none"
      arrow="never"
    >
      <el-carousel-item
        v-for="(item, index) in images"
        :key="`item-${index}`"
      >
        <div
          :style="{
            'background-image': `url(${item})`
          }"
          class="BackgroundCarousel__img"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import Vue from 'vue';
import { Carousel, CarouselItem } from 'element-ui';

Vue.use(Carousel);
Vue.use(CarouselItem);

export default {
  name: 'BackgroundCarousel',
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.BackgroundCarousel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}
.BackgroundCarousel__img {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
/deep/ .el-carousel,
/deep/ .el-carousel .el-carousel__container {
  height: 100%;
}
</style>
